<nz-spin [nzSpinning]="loading$ | async"
  ><nz-table
    #basicTable
    [nzData]="listOfData"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '700px' }">
    <thead>
      <tr>
        <th scope="col" nzWidth="400px">Name</th>
        <th scope="col" nzWidth="350px"></th>
        <th scope="col" nzWidth="100px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data; let i = index">
        <td nzWidth="400px">{{ data.name }}</td>
        <td nzWidth="300px">
          <div class="action-btn-wrapper" *ngIf="data.isEnabled">
            <button
              nz-button
              nzType="default"
              (click)="openEnterDataDrawer(i + 1)">
              Enter Data
            </button>
            <button
              nz-button
              nzType="default"
              (click)="openDataGraphsDrawer(i + 1)">
              Graph
            </button>
            <button
              nz-button
              nzType="default"
              (click)="printDatasheet(i + 1, data)"
              [nzLoading]="data.isPrintLoading">
              Datasheet
            </button>
          </div>
        </td>
        <td nzWidth="100px">
          <button
            nz-button
            nzType="text"
            class="primary-text-btn"
            *ngIf="i > 0"
            (click)="toggleData(data.isEnabled, i + 1)">
            {{ !data.isEnabled ? 'Enable' : 'Disable' }}
          </button>
        </td>
      </tr>
    </tbody></nz-table
  >
  <app-confirm-dialog
    [isVisible]="showConfirmDialog"
    [title]="'Disable Datasheet'"
    message="Are you sure you want to disable this datasheet?"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Disable'"
    [loading]="isDeleting"
    (confirmed)="removeDatasheet()"
    (cancelled)="handleCancel()"
    (closed)="handleCancel()">
  </app-confirm-dialog>

  <ng-template #drawerTitleEnterData>
    <app-drawer-header [title]="'Data'" [subtitle]="''" [breadcrumbText]="''">
    </app-drawer-header>
  </ng-template>

  <ng-template #drawerTitleDataGraph>
    <app-drawer-header [title]="'Data'" [subtitle]="''" [breadcrumbText]="''">
    </app-drawer-header>
  </ng-template>
</nz-spin>
